import { render } from "./ClientAdvisorHome.vue?vue&type=template&id=ea355542"
import script from "./ClientAdvisorHome.vue?vue&type=script&lang=js"
export * from "./ClientAdvisorHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__